import React from 'react';
import styles from './newsEditor.module.css';

const ImageUploadPreview = ({ label, image, setImage, imgText, setImgText }) => {


    const handleImageChange = (e) => {
        const file = e.target.files[0];
        if (file) {
            setImage({
                url: URL.createObjectURL(file),
                name: file.name,
                file: file
            });
        }
    };
    const handleTextChange = (e) => {
        setImgText(e.target.value);
    };

    return (
        <div className={styles.imagePreview}>
            <div className={styles.imgPreviewDiv}>
                <label className={styles.customFileLabel}>
                    Datei wählen
                    <input type="file" accept="image/*" onChange={handleImageChange} hidden />
                </label>
                <label className={styles.imgText}>
                    Text zum Bild:
                    <input
                        type="text"
                        value={imgText || ''}
                        onChange={handleTextChange}
                        placeholder="Bildbeschreibung eingeben"
                    />
                </label>
                {image?.name && <div className={styles.fileName}>{image.name}</div>}
            </div>
            {image?.url && <img src={image.url} alt="Preview" className={styles.previewImage} />}
        </div>
    );
};

export default ImageUploadPreview;
